var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-md hover:shadow-xl rounded-xl transition-all delay-100 duration-75 min-h-80",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-100 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [
          _vm._t("header"),
          _c(
            "div",
            {
              staticClass:
                "ml-8 p-5 mt-24 z-10 my-4 flex gap-4 max-h-30 justify-end",
            },
            [_vm._t("default")],
            2
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "h-28 rounded-xl justify-between items-start text-semibold w-full pl-6 pt-5 pr-6 mt-10",
        },
        [_vm._t("managerdetail")],
        2
      ),
      _c(
        "div",
        { staticClass: "mx-10 pr-3 my-3 pt-24 pb-5 flex gap-6" },
        [_vm._t("invitebtn")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }